<div [class]="cssClasses" [attr.role]="role" [attr.aria-label]="ariaLabel">
  @if (variant === 'spinner') {
    <!-- Spinner Variant -->
    <div [class]="spinnerClasses">
      <div class="ccl-loading__spinner-ring"></div>
    </div>
  }

  @if (variant === 'bar') {
    <!-- Progress Bar Variant -->
    <div class="ccl-loading__bar-container">
      <div [class]="barClasses"></div>
    </div>
  }

  @if (variant === 'pulse') {
    <!-- Pulse Variant -->
    <div [class]="pulseClasses">
      <div class="ccl-loading__pulse-dot"></div>
      <div class="ccl-loading__pulse-dot"></div>
      <div class="ccl-loading__pulse-dot"></div>
    </div>
  }
</div>
